<div class="sticky-top" id="section-demenagement">
  <app-back-to-top></app-back-to-top>
</div>
<div>
  <!-- Div to make sticky-top work on ios -->
  <app-static-container headerImage="7">
    <h1 appFocusOnInit id="titre-page" class="titre-page">{{ 'demenagement.header' | translate }}</h1>

    <h2 id="titre-section" class="titre-section">{{ 'demenagement.titre' | translate }}</h2>

    <section class="text-content">
      <div class="paragraph-group">
        <p>{{ 'demenagement.texte' | translate }}</p>
        <ul>
          <li>{{ 'demenagement.point-1' | translate }}</li>
          <li>{{ 'demenagement.point-2' | translate }}</li>
          <li>{{ 'demenagement.point-3' | translate }}</li>
          <li>{{ 'demenagement.point-4' | translate }}</li>
          <li>{{ 'demenagement.point-5' | translate }}</li>
        </ul>
      </div>
    </section>
  </app-static-container>

  <div class="sub-footer" id="sub-footer" [appDynamicBackgroundImage]="getBackgroundImageSource()">
    <app-dialog-faq class="faq-button" buttonStyle="default" position="right" id="'faq'"></app-dialog-faq>
  </div>
</div>
